module.exports = __webpack_public_path__ + "img/100.8d91314c.jpg";